<template>
  <div>
    <QueryFrame
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      :current="page"
      :count="count">
      <div slot="queryParams" class="queryContainer">
        <div class="queryItem" v-if="roleType!==2">
          <label>门店名称:</label>
          <storeListSelect class="item" v-model="query.storeIdList" ></storeListSelect>
        </div>
        <div class="queryItem">
        <goodsSearchItem v-model="query.nameMix"></goodsSearchItem> </div>
        <div class="queryItem">
          <label>来源:</label>
       <lk-select class="item" clearable v-model.trim='query.source'>
                  <lk-option v-for="(item,index) in sourceList" :key="index" :value='item'>
                    {{item}}
                  </lk-option>
                </lk-select>
        </div> <div class="queryItem">
          <label>创建时间:</label>
          <timeStampDatePicker
            class="item"
            type="daterange"
            clearable
            placeholder="请选择"
            v-model="query.duration"
           >
          </timeStampDatePicker>
        </div>
        <div class="queryItem">
          <label>患者姓名:</label>
          <lk-input class="item" v-model.trim="query.patientName" :maxlength="50" clearable placeholder="请输入"></lk-input>
        </div>
        <div class="queryItem">
          <label>状态:</label>
          <lk-select class="item" v-model.trim="query.status" :maxlength="50" clearable>
            <lk-option value="1">未使用</lk-option>
            <lk-option value="2">已失效</lk-option>
            <lk-option value="3">已使用</lk-option>
          </lk-select>
        </div>


        <div class="queryItem">
          <lk-button type="primary" class="mr" @click="handleSearch">查询</lk-button>
          <lk-button @click="handleReset()">重置</lk-button>
        </div>
      </div>
      <div slot="table" class="mt8">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>

  </div>
</template>

<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import sale from '../../services/sale';
// import goods from '../../services/goods';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'aidApplyList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  computed: {

  },
  data() {
    return {

      query: {
        storeIdList: [],
        duration: [],
      },

      columns: [
        {
          title: '门店名称',
          key: 'epStoreName',
          minWidth: 116,
          tooltip: true,
          fixed: 'left',
        },
        {
          title: '对接方',
          key: 'epSource',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '创建时间',
          key: 'epCreateTime',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '援助申请单号',
          key: 'epCode',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '患者姓名',
          key: 'epPatientName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '联系方式',
          key: 'epPatientPhone',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '状态',
          key: 'epStatusName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '物流公司',
          key: 'expressCompany',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '物流单号',
          key: 'expressCode',
          minWidth: 116,
          tooltip: true,
        },

        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 116,
          render: (h, { row }) => h('div', [
            this.handlePermission('aidApplyCheck') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'aidApplyCheck', params: { id: row.epId } });
                },
              },
            }, '查看') : null,
            this.handlePermission('aidSale') && row.isGoodsBaseOnly === 2 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  if (row.epOrderId) {
                    this.$router.push({ name: 'salesOrderCheck', params: { id: row.epOrderId } });
                  } else {
                    this.$router.push({ name: 'aidSale', params: { id: row.epId } });
                  }
                },
              },
            }, row.epOrderId ? '查看订单' : '审核发放') : null,
          ]),
        },
      ],
      tableData: [],
      warehouseList: [],
      sourceList: [],

    };
  },
  methods: {
    getSourceList() {
      sale.getSourceList({ typeList: [4] }).then((res) => {
        if (res.data.status === 200) {
          this.sourceList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.duration) {
        this.params.createTimeStart = this.params.duration[0];
        this.params.createTimeEnd = this.params.duration[1];
      }
      this.params.typeList = [4];
      // this.params.purchaseType = 2;
      sale.getPrescriptionList(this.params)
        .then((res) => {
          if (res.data.status === 200) {
            this.tableData = [];
            const { count, list } = res.data.data;
            list.forEach((item) => {
              const result = {};
              // inventoryItem.mah = item.goodsInfoVo.mah;
              utils.exchangeTable(item, result);
              result.epCreateTime = utils.exchangeTime(result.epCreateTime);
              this.tableData.push(result);
            });
            this.count = count;
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },


    handleReset() {
      this.query = {
        storeIdList: [],
        duration: [],
      };
    },
  },
  created() {
    this.getSourceList();
    this.handleSearch(true);

    // if (this.roleType !== 2) {
    //   this.columns.splice(1, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    // }
  },
};
</script>

<style lang="less" scoped>
  .queryContainer {
    transition: all 1s
  }
</style>
